import { render, staticRenderFns } from "./Userslists.vue?vue&type=template&id=cc0715a2"
import script from "./Userslists.vue?vue&type=script&lang=js"
export * from "./Userslists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports